import type { RowDef } from "./schema";

/**
 * Units that were baked into labels ("Ray Distance (× model)"). The label
 * string itself is left alone — it is iJewel's, and the parity checks read it —
 * but the row SHOWS it as "Ray Distance" with "× model" after the value, where
 * a unit belongs. Only real units are lifted; "(Legacy)", "(same name)" and the
 * like are part of the name.
 */
const UNIT = /\s*\((px|°|deg|ms|s|mm|%|× model|x model)\)\s*$/;

export function splitUnit(label: string, unit?: string): { text: string; unit?: string } {
  const m = label.match(UNIT);
  if (!m) return { text: label, unit };
  return { text: label.slice(0, m.index).trimEnd(), unit: unit ?? m[1] };
}

export function fmtRange(v: number): string {
  if (!Number.isFinite(v)) return v > 0 ? "∞" : "−∞";
  if (Number.isInteger(v)) return String(v);
  return String(Number(v.toPrecision(4)));
}

/** "0 – 4 · step 0.01", for the hover card. */
export function rangeText(row: RowDef, unit?: string): string | undefined {
  if (row.kind !== "slider" && row.kind !== "number" && row.kind !== "vec3") return undefined;
  const min = "min" in row ? row.min : undefined;
  const max = "max" in row ? row.max : undefined;
  const step = "step" in row ? row.step : undefined;
  if (min == null && max == null) return step ? `Step ${fmtRange(step)}` : undefined;
  const u = unit ? ` ${unit}` : "";
  const span = `${min != null ? fmtRange(min) : "…"} – ${max != null ? fmtRange(max) : "…"}${u}`;
  return step ? `${span} · step ${fmtRange(step)}` : span;
}
